import Container from "@client/content/Containers/container";
import { CountdownDiv } from "@client/content/hocs/countdown";
import { getContainerProps, getEntityRef } from "@client/content/lib/helper";
import ContentTextStyle from "@client/content/Style/Text";
import { type RootContainerProps } from "@client/content/types";
import { type CountdownOptions } from "@client/lib/jquery/countdown";
import * as React from "react";

import "./style.less";

export type CountdownTimersComponentProps = RootContainerProps & {
  className: string;
  countdownOptions: CountdownOptions;
};

export default (props: CountdownTimersComponentProps) => (
  <Container className="wsc_content_countdown_timer" {...getContainerProps(props)}>
    <ContentTextStyle {...getEntityRef(props)} textSubSelector=".countdown-box > span" />
    <ContentTextStyle {...getEntityRef(props)} textSubSelector=".countdown-box > .number" prefix="number" />

    <CountdownDiv className={props.className} countdownOptions={props.countdownOptions} />
  </Container>
);
